module.exports = __webpack_public_path__ + "static/img/s3.bc566c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s3.png
// module id = /EDU
// module chunks = 0